var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditEent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3156",
    "data-name": "Group 3156",
    transform: "translate(-1525 -347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M8.3,2.661l3.654,3.654L4.017,14.249l-3.258.36A.685.685,0,0,1,0,13.852l.362-3.26L8.3,2.661Zm5.914-.544L12.5.4a1.371,1.371,0,0,0-1.938,0L8.943,2.016,12.6,5.67l1.614-1.614A1.371,1.371,0,0,0,14.211,2.117Z",
    transform: "translate(1536.041 358.107)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    transform: "translate(1525 347)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEent);
export default __webpack_public_path__ + "static/media/editEent.18c7827102712fd1814e87b08068fa4b.svg";
export { ForwardRef as ReactComponent };